import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LOCALE_ID, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { IntlTelInputComponent } from "intl-tel-input/angular";
import { CarouselModule } from "ngx-owl-carousel-o";
import { TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppRoutingModule } from "./app-routing.module";
import { AuthModule } from "./auth/auth.module";
import { AppComponent } from "./app.component";
import { NavbarComponent } from "./components/layouts/navbar/navbar.component";
import { PreloaderComponent } from "./components/layouts/preloader/preloader.component";
import { HomeOneComponent } from "./components/pages/home-one/home-one.component";
import { ContactPageComponent } from "./components/pages/contact-page/contact-page.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { ButtonHoverDirective } from "./directives/button-hover.directive";

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        PreloaderComponent,
        HomeOneComponent,
        ContactPageComponent,
        FooterComponent,
        ButtonHoverDirective,
    ],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        IntlTelInputComponent,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AuthModule,
        CarouselModule,
        TranslateModule.forRoot({
            fallbackLang: "fr",
        }),
    ],
    providers: [
        { provide: LOCALE_ID, useValue: "fr-FR" },
        ...provideTranslateHttpLoader({
            prefix: "/assets/i18n/",
            suffix: ".json",
        }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
